export const manifest = {
  screens: {
    scr_ms7fzn: { name: "1 · UK Localization Strategy", route: "/", state: {"slide":0}, position: {"x":160,"y":220} },
    scr_b3fw27: { name: "2 · The Challenge", route: "/", state: {"slide":1}, position: {"x":1560,"y":220} },
    scr_liz6eg: { name: "3 · The Concept", route: "/", state: {"slide":2}, position: {"x":18360,"y":220} },
    scr_a0hd2a: { name: "4 · Top-of-Funnel Engagement", route: "/", state: {"slide":3}, position: {"x":11360,"y":220} },
    scr_r1lxqc: { name: "5 · Above-Brand Portfolio Hub", route: "/", state: {"slide":4}, position: {"x":19760,"y":220} },
    scr_9lmrow: { name: "6 · Qualified Traffic", route: "/", state: {"slide":5}, position: {"x":21160,"y":220} },
    scr_ab4sly: { name: "7 · Summary", route: "/", state: {"slide":6}, position: {"x":7160,"y":220} },
  },
  sections: {
    sec_k9nyik: { name: "Webinar to Series Strategy", x: 0, y: 0, width: 22520, height: 1180 },
    sec_vistwo: { name: "Campaign Execution", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_cieylm: { name: "Operations & Commercial", x: 0, y: 3960, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_k9nyik", children: [
      { kind: "screen", id: "scr_ms7fzn" },
      { kind: "screen", id: "scr_b3fw27" },
      { kind: "screen", id: "scr_ab4sly" },
      { kind: "screen", id: "scr_a0hd2a" },
      { kind: "screen", id: "scr_liz6eg" },
      { kind: "screen", id: "scr_r1lxqc" },
      { kind: "screen", id: "scr_9lmrow" },
    ] },
    { kind: "section", id: "sec_vistwo", children: [] },
    { kind: "section", id: "sec_cieylm", children: [] },
  ],
}
